import { render, staticRenderFns } from "./AppMiniDialog.vue?vue&type=template&id=10cb02e4&"
import script from "./AppMiniDialog.vue?vue&type=script&lang=ts&"
export * from "./AppMiniDialog.vue?vue&type=script&lang=ts&"
import style0 from "./AppMiniDialog.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VDialog } from 'vuetify/lib/components/VDialog';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSpacer } from 'vuetify/lib/components/VGrid';
installComponents(component, {VDialog,VRow,VSpacer})
